module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bF6fI"))).then(() => parcelRequire('d0iPb'));